export function flattenAndCountChildren(facetTree: FacetTree) {
  let totalChildren = 0

  for (const key in facetTree) {
    const node = facetTree[key]

    if (node.children && Object.keys(node.children).length > 0) {
      totalChildren += Object.keys(node.children).length

      totalChildren += flattenAndCountChildren(node.children)
    }
  }

  return totalChildren
}
